export const Percentage = ({ percent }) => {
    // Create our number formatter.
    const formatter = new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 2,
        style: 'percent'
    });

    return formatter.format(percent / 100.0);
};
